import React from 'react';
import PropTypes from 'prop-types';
import FileViewer from 'react-file-viewer';

/*
react-file-viewer draws an image with no alt text, so an image preview is exposed as one image
named by the description written at upload, or by the file name when there is none (WCAG 1.1.1).
PDFs keep the viewer as it is: it has its own controls, which must stay reachable.
*/
const AttachmentViewer = ({ description, fileName, fileType, filePath, onError }) => {
  const viewer = <FileViewer fileType={fileType} filePath={filePath} onError={onError} />;

  if (fileType === 'pdf') {
    return viewer;
  }

  return (
    <div role="img" aria-label={description || fileName || 'Attached image'} className="h-100">
      <div aria-hidden="true" className="h-100">
        {viewer}
      </div>
    </div>
  );
};

AttachmentViewer.propTypes = {
  description: PropTypes.string,
  fileName: PropTypes.string,
  filePath: PropTypes.string,
  fileType: PropTypes.string,
  onError: PropTypes.func
};

AttachmentViewer.defaultProps = {
  description: '',
  fileName: '',
  filePath: '',
  fileType: '',
  onError: () => {}
};

export default AttachmentViewer;
